import { LobeStatus } from '@shure/shared/angular/data-access/system-api/core';
import { mapFragmentFeaturesToModel } from '@shure/shared/angular/data-access/system-api/mappers';
import { PositionUnit } from '@shure/shared/angular/utils/utils-position';

import { CoverageDeviceDebug } from '../../api/models';
import { DeviceCoverageDeviceDebugFragment } from '../graphql/generated/device-coverage-device-debug.generated';

import { mapToPositionUnitRange } from './coverage-device.mapper';

export function mapCoverageDeviceDebugFromSysApi(
	deviceFragment: DeviceCoverageDeviceDebugFragment
): CoverageDeviceDebug {
	const id = deviceFragment.id;
	return {
		id,
		features: mapFragmentFeaturesToModel(deviceFragment, {
			dspDebugAudioFenceLobes: () => ({
				value: (deviceFragment.features.dspDebugAudioFenceLobes?.dspDebugAudioFenceLobes ?? [])
					.filter((fencedLobeFragment) => fencedLobeFragment.features.lobe != null)
					.map((fencedLobeFragment) => ({
						id: fencedLobeFragment.id,
						index: fencedLobeFragment.description.index,
						status: fencedLobeFragment.features.lobe?.status ?? LobeStatus.NotDeployed,
						position: {
							x: PositionUnit.fromRaw(fencedLobeFragment.features.lobe?.position.xPosition ?? 0),
							y: PositionUnit.fromRaw(fencedLobeFragment.features.lobe?.position.yPosition ?? 0)
						},
						constraints: {
							beam: fencedLobeFragment.description.constraints.lobe?.position
								? {
										axisX: mapToPositionUnitRange(
											fencedLobeFragment.description.constraints.lobe?.position.xPosition.range
										),
										axisY: mapToPositionUnitRange(
											fencedLobeFragment.description.constraints.lobe?.position.yPosition.range
										)
									}
								: undefined
						}
					}))
			})
		})
	};
}
